import React from 'react'
import Fab from '@mui/material/Fab'
import { styled } from '@mui/material'

const StyledFab = styled(Fab)(({ theme, style }) => ({
    textTransform: 'capitalize !important',
    backgroundColor: theme?.palette?.background?.paper,
    color: theme?.palette?.primary?.main,
    border: `solid 1px ${theme?.palette?.primary?.main}`,
    boxShadow: 'none',
    overflow: 'hidden',
    ...style, // Apply dynamic styles passed via props
    ...(style?.width && { width: `${style.width}!important` }), // Handle width with !important if provided
    '& .MuiFab-label': {
        lineHeight: 1,
        wordBreak: 'break-all',
    },
}))

const ExtendedFab = ({ style, label, onClick, ...rest }) => {
    return (
        <StyledFab
            style={style}
            variant="extended"
            onClick={onClick}
            {...rest}
        >
            {label}
        </StyledFab>
    )
}

export default ExtendedFab
